module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.initialLoading || _vm.languageUpdateFix) ? _c('loading') : [_c('filters', {
    attrs: {
      "availableFields": _vm.options.fields,
      "enabledFields": _vm.enabledFieldsFilter,
      "filters": _vm.filters,
      "enabledFilters": _vm.options.enabledFilters,
      "availableFilters": _vm.options.availableFilters
    },
    on: {
      "update:enabledFields": function($event) {
        _vm.enabledFieldsFilter = $event
      },
      "update:filters": function($event) {
        _vm.filters = $event
      },
      "update": _vm.filter,
      "export": _vm.exportData
    }
  }), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('b-table', {
    ref: "itemsTable",
    staticClass: "search-table-data",
    attrs: {
      "striped": "striped",
      "items": _vm.items,
      "fields": _vm.enabledTranslatedFields,
      "noLocalSorting": true
    },
    on: {
      "sort-changed": _vm.updateSort,
      "filtered": _vm.calculateHeight
    },
    scopedSlots: _vm._u([_vm._l((_vm.enabledTranslatedFields), function(value, key) {
      return {
        key: value.key ? value.key : key,
        fn: function(data) {
          return [_c('b-link', {
            attrs: {
              "disabled": _vm.openItemUrl == null,
              "to": _vm.getToUrl(data.item),
              "data-fieldname": value.key ? value.key : key
            }
          }, [_vm._v(_vm._s(data.value))])]
        }
      }
    })])
  })], 1), _c('div', {
    staticClass: "row table-footer"
  }, [_c('div', {
    staticClass: "col-6 col-lg-4"
  }, [_vm._v(_vm._s(_vm.paginationText))]), _c('div', {
    staticClass: "col-6 col-lg-4"
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.paginationOptions
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-lg-4"
  }, [_c('b-pagination', {
    attrs: {
      "align": "right",
      "total-rows": _vm.total,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1214d6d2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/search-table/SearchTable.vue
// module id = 2005
// module chunks = 1